module.exports = __webpack_public_path__ + "static/media/star-swirl.3045bd1f.svg";